import React from 'react'
import { useIntl } from 'react-intl'

import { Text } from '@/components/common'
import FeaturesPotentialHeader from '@/components/sections/FeaturesPotentialHeader'
import TextImageRow from '@/components/sections/TextImageRow'
import KeepTrackBox from '@/components/sections/KeepTrackBox'
import CertifiedHardwarePartners from '@/components/sections/CertifiedHardwarePartners'
import CustomerSupport from '@/components/sections/CustomerSupport'
import BuyNowCta from '@/components/BuyNowCta'
import { Layout, Row, Rows, Section } from '@/components/layout'
import liveData from '@/assets/automated-insights/live-data.jpg'
import monitorExpense from '@/assets/automated-insights/monitor-expense.png'
import connectAccount from '@/assets/automated-insights/connect-account.jpg'
import pairReceipts from '@/assets/automated-insights/pair-receipts.jpg'
import realTimeInsights from '@/assets/automated-insights/real-time-insights.png'
import customInvoices from '@/assets/automated-insights/custom-invoices.jpg'

const pageId = 'automatedInsights'
export default function AutomatedInsights() {
  const { formatMessage } = useIntl()
  const getPageMessage = (id) => formatMessage({ id: `pages.${pageId}.${id}` })

  return (
    <Layout.Content>

      <FeaturesPotentialHeader
        altImgOne={getPageMessage('main.header.altImgOne')}
        altImgTwo={getPageMessage('main.header.altImgTwo')}
        canTry={false}
        descriptionImgOne={getPageMessage('main.header.descriptionImgOne')}
        descriptionImgTwo={getPageMessage('main.header.descriptionImgTwo')}
        pathImgOne={liveData}
        pathImgTwo={monitorExpense}
        skuValue="neataiyr"
        smallPrint={getPageMessage('main.header.smallPrint')}
        subtitle={getPageMessage('main.header.subtitle')}
        title={getPageMessage('main.header.title')}
      />

      <div className="automated-features">
        <Section>
          <Rows gap={0}>
            <Row center textCenter>
              <h2 className="c-brand">No Learning Curve – Get Started in Minutes!</h2>
            </Row>
            <Row center textCenter>
              <p>Neat’s automated expense tracking integrates with your existing workflow, helping you manage expenses effortlessly with minimal setup.</p>
            </Row>
          </Rows>
        </Section>

        <TextImageRow
          image={connectAccount}
          text={getPageMessage('main.features.connectBankAccount')}
          title="Connect Bank Account"
        />

        <TextImageRow
          image={pairReceipts}
          reverse
          text={getPageMessage('main.features.pairReceipts')}
          title="Pair receipts with expenses"
        />

        <TextImageRow
          image={monitorExpense}
          text={getPageMessage('main.features.accountingReports')}
          title="Accounting Reports"
        />

        <TextImageRow
          image={realTimeInsights}
          reverse
          text={getPageMessage('main.features.realTimeInsights')}
          title="Real-time insights"
        />

        <TextImageRow
          image={customInvoices}
          text={getPageMessage('main.features.customInvoices')}
          title="Custom Invoices"
        />
      </div>

      <CustomerSupport
        bgFullyVisible
        bgImage="/automated-insights/ai-banner.webp"
        description="Never miss a deduction again—Neat automatically tracks, organizes, and categorizes expenses so you’re always prepared for tax season."
        title="Stay Tax-Ready with Smart Expense Tracking Software"
      />

      <Section>
        <Text.H2 center>Simplify with Neat Automated Expense Tracking Software</Text.H2>
        <BuyNowCta sku="neataiyr" style={{ border: '0' }} />
        <Text center size="xsmall">Automated Insights cannot be purchased without a Neat subscription.</Text>
      </Section>

      <Section>
        <Rows gap={0}>
          <Row center textCenter>
            <h2 className="c-brand">Fast & Easy Expense Tracking</h2>
          </Row>
        </Rows>
      </Section>

      <KeepTrackBox
        bottomSectionTitle="Simplify with Neat Automated Expense Tracking Software"
        canTry={false}
        skuValue="neataiyr"
        smallPrint="Automated Insights cannot be purchased without a Neat subscription."
      />

      <CertifiedHardwarePartners />

      <CustomerSupport />

      <Section>
        <Text.H2 center>Simplify with Neat Automated Expense Tracking Software</Text.H2>
        <BuyNowCta sku="neataiyr" style={{ border: '0' }} />
        <Text center size="xsmall">Automated Insights cannot be purchased without a Neat subscription.</Text>
      </Section>

    </Layout.Content>
  )
}

AutomatedInsights.layoutProps = {
  pageId,
}
